// Meta Pixel integration for React SPA
// - Initializes fbq once
// - Tracks PageView on route changes
// - Provides helpers for standard events

/* eslint-disable */
const PIXEL_ID = import.meta.env.VITE_FB_PIXEL_ID || '1208291925910717';
const TEST_EVENT_CODE = import.meta.env.VITE_FB_TEST_EVENT_CODE || undefined;

// Enable only in development by default to avoid impacting production until verified
const isDev = !!import.meta.env.DEV;
const isExplicitlyEnabled = import.meta.env.VITE_ENABLE_META_PIXEL === 'true';
const META_PIXEL_ENABLED = isDev || isExplicitlyEnabled;

function ensureFbqInitialized() {
  if (!META_PIXEL_ENABLED || typeof window === 'undefined') return false;
  if (window.fbq) return true;

  // Official Meta Pixel bootstrap snippet
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () { n.callMethod ?
      n.callMethod.apply(n, arguments) : n.queue.push(arguments) }; if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = true; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = true;
    t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  try {
    window.fbq('init', PIXEL_ID);
    return true;
  } catch (_e) {
    return false;
  }
}

export function initMetaPixel() {
  ensureFbqInitialized();
}

export function trackEvent(eventName, params = {}) {
  if (!META_PIXEL_ENABLED || typeof window === 'undefined' || !window.fbq) return;
  const payload = { ...params };
  if (TEST_EVENT_CODE) payload.test_event_code = TEST_EVENT_CODE;
  try {
    window.fbq('track', eventName, payload);
  } catch (_e) {
    // no-op
  }
}

export function trackPageView(params = {}) {
  trackEvent('PageView', params);
}

export function trackCompleteRegistration(params = {}) {
  trackEvent('CompleteRegistration', params);
}

export function isMetaPixelEnabled() {
  return META_PIXEL_ENABLED;
}


